import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Component to scroll to top when route changes
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when pathname changes
    // UI/UX REFRESH - Jump instantly so the incoming page fades in at the top,
    // instead of visibly scrolling the new page up from the old scroll position
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
